import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { API_CALLS } from "../../../../API/api_calls";
import { useAppSelector } from "../../../../redux";
import { ArticleProps } from "../../../../redux/slices/article/Article";

const ArticleTitle = () => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const { draftArticle } = useAppSelector((state) => state.article);
  const {
    post_id,
    content_id,
    content_type,
    row_config,
    content_data,
    article_order,
  } = draftArticle.title_content as ArticleProps.WithTextContent;

  const { element_role } = row_config;
  const [titleValue, setTitleValue] = useState(content_data?.Blueprint ?? "");

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "38px";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [titleValue]);

  const handleBlur = () => {
    if (titleValue === content_data?.Blueprint) return;
    API_CALLS.ARTICLE.createOrUpdateArticleContent({
      post_id,
      content_type,
      content_id,
      element_role,
      article_order,
      content_data: JSON.stringify({
        Blueprint: titleValue,
      }),
    });
  };

  return (
    <TitleContainer>
      <textarea
        ref={textareaRef}
        name="title"
        id="article-title"
        value={titleValue}
        onChange={(e) => setTitleValue(e.target.value)}
        onBlur={handleBlur}
        placeholder="Title"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
    </TitleContainer>
  );
};

export default ArticleTitle;

const TitleContainer = styled.div`
  max-width: 906px;
  width: 100%;

  textarea {
    width: 100%;
    border: none;
    padding: 0;
    font-weight: ${({ theme }) =>
      theme.typography.Heading.L["font-weight-semibold"]};
    font-size: ${({ theme }) => theme.typography.Heading.L["font-size"]}rem;
    resize: none;
    outline: none;
    overflow: hidden;
    box-sizing: content-box;

    &::placeholder {
      color: ${({ theme }) => theme.Color.text["text-placeholder"].value};
    }
  }
`;
